import useFilterInput from '../../../hooks/useFilterInput';
import { useContext, useMemo } from 'react';
import visTypeCheckers from '../../../types/visTypeCheckers';
import CurrentUserContext from '../../../contexts/CurrentUserContext';
import cardTypeCheckers from '../../../types/cardTypeCheckers';

const useIsInvalidFilterInput = (canvas: Canvas) => {
  const { isFleetOpsStaff } = useContext(CurrentUserContext);
  const { lastDrilldown } = useFilterInput({ extractEntityFilter: true });

  const usesGroupVsRemainderVis = useMemo(() => {
    for (let c of canvas.cards) {
      if (
        cardTypeCheckers.isDashboardGadget(c) &&
        visTypeCheckers.isGroupVsRemainder(c.content)
      ) {
        return true;
      } else if (
        cardTypeCheckers.isChartDefinition(c) &&
        visTypeCheckers.isGroupVsRemainder(c.content)
      ) {
        return true;
      }
    }
    return false;
  }, [canvas]);

  const invalidFilterInput = useMemo(() => {
    if (!usesGroupVsRemainderVis) return false;

    return (
      lastDrilldown?.wildcardFilters?.length || lastDrilldown?.ranges?.length
    );
  }, [
    lastDrilldown?.ranges?.length,
    lastDrilldown?.wildcardFilters?.length,
    usesGroupVsRemainderVis,
  ]);

  return invalidFilterInput && isFleetOpsStaff;
};

export default useIsInvalidFilterInput;
